(() => {
  class LedpanelCraft extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      document.querySelectorAll('product-info, .product, .product-information').forEach((el) => {
        el.classList.add('product--ledpanelcraft');
        if (window.HarfmixCraftPdp) window.HarfmixCraftPdp.init({ quoteOnly: true });
      });
    }
  }

  if (!customElements.get('ledpanel-craft')) {
    customElements.define('ledpanel-craft', LedpanelCraft);
  }
})();
